// A linha "NiceQuest" da comparação do Buscar Produto (Adnéia, 03/11/2026).
// Regra desde 28/09: NiceQuest não sai de SP; sai de SC e de ES. É a mesma do backend
// (produtos_busca.py, _ufs_bloqueadas e NOTA_NICE_SP) e do Smart Compras
// (FILIAL_PROIBIDA_POR_CANAL = {"NCQ": {3}}). A linha ainda seguia a de 17/09 ("só despacha
// de SP") e dizia o contrário: em 03/11, a entrega 127918211 (NiceQuest, item VENT0055, 7 no
// físico do ES e 0 em SP) aparecia como "não atende — sem estoque em SP".

export const UF_FORA_NICEQUEST = 'SP';

// ['ES','SP'] -> { atende: true, ufs: ['ES'] }; ['SP'] ou [] -> { atende: false, motivo }.
export function niceQuestAtende(ufsComEstoque) {
  const ufs = (ufsComEstoque || []).map(u => String(u || '').trim().toUpperCase()).filter(Boolean);
  const fora = [...new Set(ufs.filter(u => u !== UF_FORA_NICEQUEST))].sort();
  if (fora.length > 0) return { atende: true, ufs: fora };
  return {
    atende: false,
    ufs: [],
    motivo: ufs.includes(UF_FORA_NICEQUEST) ? 'estoque só em SP' : 'sem estoque',
  };
}
